// Note: The first file of a module here, must also register the module

import "./signature-settings.component";
import "./view-signature-dialog.component";
import "./view-summary-dialog.component";
